import CountryPageRenderer from '../components/CountryPageRenderer';
import ecuadorData from '../data/country-pages/ecuador';

export default function EcuadorCountryPage() {
  return <CountryPageRenderer data={ecuadorData} />;
}
